"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShopifyGid = void 0;
/**
 * Checks if passed argument is a shopify graphql id
 *
 * @param {string} id
 * @returns {boolean}
 */

function isShopifyGid(id) {
  return id.slice(0, 6) === 'gid://';
}

exports.isShopifyGid = isShopifyGid;